// Typed `localStorage` accessor — every key must be a member of the
// `LocalStorageKey` dox union (see `ui/editor.dox`). The wire string
// (the actual `localStorage` slot name) is resolved via
// `illuminateLocalStorageKey`. A typo at the call site is a tsc error
// instead of a silent `localStorage.getItem("blame-witdh")` no-op.

import { illuminateLocalStorageKey, validLocalStorageKey } from "../../.dox/ui";
import type { LocalStorageKey } from "../../.dox/ui";

export type { LocalStorageKey };
export { validLocalStorageKey };

// Resolve a dox tag to the wire key used by `localStorage`.
export const getStorageKey = (key: LocalStorageKey): string =>
  illuminateLocalStorageKey(key);

export const setItem = (key: LocalStorageKey, value: string): void => {
  localStorage.setItem(getStorageKey(key), value);
};

export const getItem = (key: LocalStorageKey): string | null =>
  localStorage.getItem(getStorageKey(key));

export const removeItem = (key: LocalStorageKey): void => {
  localStorage.removeItem(getStorageKey(key));
};
